import { jwtDecode } from 'jwt-decode';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Login from '../../pages/Login/Login';
import { resetUser } from '../../redux/userReducer';
import refreshToken from './apis/refreshToken';
import checkValidToken, { checkvalidEmbedToken } from './checkValidToken';
import removeTokens from './handleLogout';

const PrivateRoutes = () => {
  const [refreshTimeout, setrefreshTimeout] = useState(false);
  const dispatch = useDispatch();
  const [googleToken, setGoogleToken] = useState(() =>
    localStorage.getItem('googleIdToken'),
  );
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.PowerBi.user);
  const userlogin = Object.keys(user).length !== 0;
  const refreshInProgressRef = useRef(false);

  const isTokenNearExpiry = (token) => {
    try {
      if (!token) return true;
      const decodedToken = jwtDecode(token);
      const remainingMs = decodedToken.exp * 1000 - Date.now();
      return remainingMs <= 10 * 60 * 1000;
    } catch (error) {
      return true;
    }
  };

  var timeOut = () => {
    clearTimeout(() => {
      setrefreshTimeout(true);
    });
    setTimeout(() => {
      setrefreshTimeout(true);
    }, 28800000); // 8 hours
  };
  const refreshgoogleToken = async () => {
    if (refreshInProgressRef.current) {
      return;
    }

    const token = localStorage.getItem('googleIdToken');
    if (!token) {
      setrefreshTimeout(true);
      return;
    }

    if (!isTokenNearExpiry(token)) {
      checkValidToken(refreshgoogleToken, token);
      return;
    }

    if (localStorage.getItem('refreshToken')) {
      refreshInProgressRef.current = true;
      try {
        const result = await refreshToken();
        if (!result) {
          localStorage.removeItem('googleIdToken');
          setrefreshTimeout(true);
          return;
        }

        localStorage.removeItem('googleIdToken');
        localStorage.setItem('googleIdToken', result);
        setGoogleToken(result);
        checkValidToken(refreshgoogleToken, result);
      } finally {
        refreshInProgressRef.current = false;
      }
    } else {
      setrefreshTimeout(true);
      return;
    }
  };
  useEffect(() => {
    if (refreshTimeout) {
      removeTokens();
      dispatch(resetUser({}));
      navigate('/', { state: { location: location } });
    }
  }, [dispatch, location, navigate, refreshTimeout]);

  useEffect(() => {
    timeOut();
  }, []);

  // Browsers throttle timers in background tabs / sleeping laptops, so the
  // scheduled refresh can be missed. Re-check the Google token on return.
  useEffect(() => {
    const onVisible = () => {
      if (
        document.visibilityState === 'visible' &&
        localStorage.getItem('refreshToken') &&
        Object.keys(user).length !== 0 &&
        isTokenNearExpiry(localStorage.getItem('googleIdToken'))
      ) {
        refreshgoogleToken();
      }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    const token = localStorage.getItem('googleIdToken');

    if (
      !localStorage.getItem('refreshToken') ||
      Object.keys(user).length === 0
    ) {
      return;
    }

    if (!checkvalidEmbedToken(token)) {
      const intialgoogleTokenSetting = async () => {
        if (localStorage.getItem('refreshToken')) {
          const result = await refreshToken();
          if (!result) {
            localStorage.removeItem('googleIdToken');
            setrefreshTimeout(true);
            return;
          }

          localStorage.removeItem('googleIdToken');
          localStorage.setItem('googleIdToken', result);
          setGoogleToken(result);
          checkValidToken(refreshgoogleToken, result);
        }
      };

      intialgoogleTokenSetting();
      return;
    }

    if (isTokenNearExpiry(token)) {
      refreshgoogleToken();
      return;
    }

    checkValidToken(refreshgoogleToken, token);
    setGoogleToken(token);
  }, [user]);

  let auth = { isloggedIn: userlogin && localStorage.getItem('refreshToken') };

  return auth.isloggedIn ? (
    <Outlet context={googleToken} />
  ) : (
    <Login location={location.pathname} />
  );
};

export default PrivateRoutes;
